// extracted by mini-css-extract-plugin
export default {"root":"IconAdministrative_root__uK7m+"};